var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[_c('div',{staticClass:"auto_1280"},[_c('ul',{staticClass:"ul clearfix"},_vm._l((_vm.linkList),function(item,index){return _c('li',{key:index},[_c('a',{staticClass:"dot",attrs:{"href":item.intro,"target":"_blank","rel":"nofollow"}},[_vm._v(_vm._s(item.title))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }